import React, { Component } from 'react'
import _ from 'lodash'
import RichTextEditor from 'react-rte'
import ProposalSections from '../ProposalSections'
import ProposalSectionsPreview from '../templates/ProposalSectionsPreview'
import ProposalMilestonesPreview from '../templates/ProposalMilestonesPreview'
import { Button, Input, Popconfirm, Form, Tabs } from 'antd'
import {
  convertToOption,
  changeProposalItemValue,
  arrayMove,
  changeSectionItemsStructure
} from '../../util'
import history from '../../history'
import ProposalMilestones from '../proposal/ProposalMilestones'
import config from '../../config'
const { API_BASE } = config

const { TextArea } = Input
const FormItem = Form.Item
const TabPane = Tabs.TabPane

class LeadProposalView extends Component {
  constructor(props) {
    super(props)

    this.state = {
      templateOptions: convertToOption(this.props.templates),
      preview: true
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.dataStructure !== state.dataStructure) {
      return {
        dataStructure: props.dataStructure
      }
    }

    if (props.milestonesDataStructure !== state.milestonesDataStructure) {
      return {
        milestonesDataStructure: props.milestonesDataStructure
      }
    }

    // Return null if the state hasn't changed
    return null
  }

  componentDidUpdate(prevProps, prevState) {
    const form = this.props.form
    if (this.props.currentId !== prevProps.currentId) {
      if (this.props.currentId === 0) {
        form.resetFields()
        this.setState({
          dataStructure: []
        })
      }
      if (this.props.currentId > 0) {
        this.props.loadProposalData(this.props.currentId)
      }
    }
  }

  handleStatusChange = e => {
    const proposalStatus = e.target.value
    this.setState(() => ({
      proposalStatus
    }))
  }

  handleOverviewChange = value => {
    this.setState({ overview: value })
  }

  handleItemChange = (e, sectionIndex, itemId) => {
    const { value } = e.target
    const { dataStructure } = this.state
    const newitemsValue = changeProposalItemValue(value, itemId, dataStructure[sectionIndex].items)
    let tmpDataStructure = dataStructure
    tmpDataStructure[sectionIndex].items = newitemsValue
    this.setState({
      dataStructure: tmpDataStructure
    })
  }

  moveItemRight = (index, sectionIndex, item) => {
    if (index !== 0) {
      const { dataStructure } = this.state
      const newSectionItemsStructure = changeSectionItemsStructure(
        'moveRight',
        dataStructure[sectionIndex].items,
        item
      )
      let tmpDataStructure = dataStructure
      tmpDataStructure[sectionIndex].items = newSectionItemsStructure
      this.setState({
        dataStructure: tmpDataStructure
      })
    }
  }

  moveItemLeft = (index, sectionIndex, item) => {
    const { dataStructure } = this.state
    const newSectionItemsStructure = changeSectionItemsStructure(
      'moveLeft',
      dataStructure[sectionIndex].items,
      item
    )
    let tmpDataStructure = dataStructure
    tmpDataStructure[sectionIndex].items = newSectionItemsStructure
    this.setState({
      dataStructure: tmpDataStructure
    })
  }

  moveItemUp = (index, sectionIndex, item) => {
    if (index !== 0) {
      const { dataStructure } = this.state
      const newSectionItemsStructure = changeSectionItemsStructure(
        'moveUp',
        dataStructure[sectionIndex].items,
        item
      )
      let tmpDataStructure = dataStructure
      tmpDataStructure[sectionIndex].items = newSectionItemsStructure
      this.setState({
        dataStructure: tmpDataStructure
      })
    }
  }

  moveItemDown = (index, sectionIndex, item) => {
    const { dataStructure } = this.state
    const newSectionItemsStructure = changeSectionItemsStructure(
      'moveDown',
      dataStructure[sectionIndex].items,
      item
    )
    let tmpDataStructure = dataStructure
    tmpDataStructure[sectionIndex].items = newSectionItemsStructure
    this.setState({
      dataStructure: tmpDataStructure
    })
  }

  handleAddItem = sectionIndex => {
    const { dataStructure } = this.state
    let tmpDataStructure = dataStructure
    if (tmpDataStructure[sectionIndex].items) {
      tmpDataStructure[sectionIndex].items.push({
        id: tmpDataStructure[sectionIndex].items.length + 1
      })
    } else {
      tmpDataStructure[sectionIndex].items = [
        {
          id: 1
        }
      ]
    }

    this.setState({
      dataStructure: tmpDataStructure
    })
  }

  handleDeleteItem = (index, sectionIndex, item) => {
    const { dataStructure } = this.state
    const newSectionItemsStructure = changeSectionItemsStructure(
      'delete',
      dataStructure[sectionIndex].items,
      item
    )
    let tmpDataStructure = dataStructure
    tmpDataStructure[sectionIndex].items = newSectionItemsStructure
    this.setState({
      dataStructure: tmpDataStructure
    })
  }

  handleMoveSectionUp = sectionIndex => {
    if (sectionIndex !== 0) {
      const { dataStructure } = this.state
      let tmpDataStructure = dataStructure
      arrayMove(tmpDataStructure, sectionIndex, sectionIndex - 1)
      this.setState({
        dataStructure: tmpDataStructure
      })
    }
  }

  handleMoveSectionDown = sectionIndex => {
    const { dataStructure } = this.state
    if (sectionIndex + 1 !== dataStructure.length) {
      let tmpDataStructure = dataStructure
      arrayMove(tmpDataStructure, sectionIndex, sectionIndex + 1)
      this.setState({
        dataStructure: tmpDataStructure
      })
    }
  }

  handleDeleteSection = sectionIndex => {
    const { dataStructure } = this.state
    let tmpDataStructure = dataStructure
    tmpDataStructure.splice(sectionIndex, 1)
    this.setState({
      dataStructure: tmpDataStructure
    })
  }

  handleAddSection = () => {
    const { dataStructure } = this.state
    let tmpDataStructure = dataStructure
    tmpDataStructure.push({
      name: `New Section - ${dataStructure.length + 1}`,
      id: dataStructure.length + 1
    })
    this.setState({
      dataStructure: tmpDataStructure
    })
  }

  handleChangeSectionName = (sectionIndex, value) => {
    const { dataStructure } = this.state
    let tmpDataStructure = dataStructure
    tmpDataStructure[sectionIndex].name = value
    this.setState({
      dataStructure: tmpDataStructure
    })
  }

  handleRevisionChange = value => {
    const { form } = this.props
    const htmlFields = ['overview']
    const revisions = JSON.parse(this.props.revisions.find(x => x.id === value).json_patch)

    let changes = {}
    revisions.forEach(revision => {
      const fieldName = revision.path.substring(1, revision.path.length)
      if (fieldName === 'proposalSections') {
        const sectionsWithItems = JSON.parse(revision.value)
        this.setState(prevState => {
          return { ...prevState, dataStructure: sectionsWithItems }
        })
      }
      if (!_.isNil(form.getFieldsValue()[fieldName])) {
        if (htmlFields.includes(fieldName)) {
          changes[fieldName] = RichTextEditor.createValueFromString(
            revision.value.toString(),
            'html'
          )
        } else {
          changes[fieldName] = revision.value.toString()
        }
      }
    })

    form.setFieldsValue(changes)
  }

  handleCreate = () => {
    const { onCreate } = this.props

    if (onCreate) {
      const form = this.props.form
      form.validateFields((err, values) => {
        if (err) {
          return
        }
        this.togglePreview()
        values.overview = values.overview.toString('html')
        const proposal = {
          proposalSections: this.state.dataStructure,
          milestones: this.state.milestonesDataStructure,
          proposalData: values
        }
        onCreate(proposal)
      })
    }
  }

  togglePreview = () => {
    this.setState({
      preview: !this.state.preview
    })
  }

  /* Schedules/Milestones actions */
  handleAddMilestone = () => {
    const newMilestone = this.state.milestonesDataStructure.push({ description: '' })
    this.setState({
      milestonesDataStructure: newMilestone
    })
  }

  handleMilestoneChange = (value, index) => {
    let newMilestonesDataStructure = this.state.milestonesDataStructure
    newMilestonesDataStructure[index].description = value
    this.setState({
      milestonesDataStructure: newMilestonesDataStructure
    })
  }

  moveMilestoneUp = index => {
    const newMilestonesDataStructure = arrayMove(
      this.state.milestonesDataStructure,
      index,
      index - 1
    )
    this.setState({
      milestonesDataStructure: newMilestonesDataStructure
    })
  }

  moveMilestoneDown = index => {
    const newMilestonesDataStructure = arrayMove(
      this.state.milestonesDataStructure,
      index,
      index + 1
    )
    this.setState({
      milestonesDataStructure: newMilestonesDataStructure
    })
  }

  handleDeleteMilestone = index => {
    const { milestonesDataStructure } = this.state
    let tmpMilestonesDataStructure = milestonesDataStructure
    tmpMilestonesDataStructure.splice(index, 1)
    this.setState({
      milestonesDataStructure: tmpMilestonesDataStructure
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { templateInfo } = this.props
    const { preview } = this.state
    return (
      <div>
        <div className="row">
          <div className="col-8">
            <h2>Proposal Template</h2>
          </div>
          <div className="col-4 text-right">
            {templateInfo && (
              <a
                href={`${API_BASE}/api/templates/proposal/${templateInfo.id}/print`}
                target="_blank"
              >
                <Button icon="printer">Print Proposal</Button>
              </a>
            )}
          </div>
        </div>

        <Form>
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-md-12">
                  <FormItem label="Template">
                    {getFieldDecorator('name', {
                      initialValue: templateInfo ? templateInfo.name : null
                    })(<Input />)}
                  </FormItem>
                </div>
              </div>
              <FormItem label="Description">
                {getFieldDecorator('description', {
                  initialValue: templateInfo ? templateInfo.description : null
                })(<TextArea placeholder="Type in description..." rows={4} />)}
              </FormItem>
              <FormItem label="Overview">
                {getFieldDecorator('overview', {
                  initialValue: templateInfo
                    ? RichTextEditor.createValueFromString(templateInfo.overview, 'html')
                    : RichTextEditor.createValueFromString('', 'html')
                })(<RichTextEditor />)}
              </FormItem>
            </div>
          </div>
        </Form>
        <div className="row">
          <div className="col-12">
            <Button icon={preview ? 'edit' : 'bars'} onClick={() => this.togglePreview()}>
              {preview ? 'Edit Specifications and Time Schedule' : 'Back to Preview'}
            </Button>
          </div>
        </div>
        {preview && (
          <div className="mt-3">
            <h4>SPECIFICATIONS:</h4>
            <ProposalSectionsPreview dataStructure={this.state.dataStructure} />

            <h4>TIME SCHEDULE:</h4>
            <ProposalMilestonesPreview
              milestonesDataStructure={
                this.state.milestonesDataStructure
                  ? this.state.milestonesDataStructure
                  : this.props.milestonesDataStructure
              }
            />
          </div>
        )}
        {!preview && (
          <Tabs defaultActiveKey="1">
            <TabPane tab="Specifications" key="1">
              <ProposalSections
                dataStructure={this.state.dataStructure}
                handleAddItem={this.handleAddItem}
                handleDeleteItem={this.handleDeleteItem}
                handleItemChange={this.handleItemChange}
                moveItemRight={this.moveItemRight}
                moveItemLeft={this.moveItemLeft}
                moveItemUp={this.moveItemUp}
                moveItemDown={this.moveItemDown}
                handleMoveSectionUp={this.handleMoveSectionUp}
                handleMoveSectionDown={this.handleMoveSectionDown}
                handleDeleteSection={this.handleDeleteSection}
                handleAddSection={this.handleAddSection}
                handleChangeSectionName={this.handleChangeSectionName}
              />
            </TabPane>
            <TabPane tab="Schedules" key="2">
              <ProposalMilestones
                milestonesDataStructure={this.state.milestonesDataStructure}
                handleAddMilestone={this.handleAddMilestone}
                handleMilestoneChange={this.handleMilestoneChange}
                moveMilestoneUp={this.moveMilestoneUp}
                moveMilestoneDown={this.moveMilestoneDown}
                handleDeleteMilestone={this.handleDeleteMilestone}
              />
            </TabPane>
          </Tabs>
        )}
        <div className="row">
          <div className="col-1">
            <Button onClick={() => history.goBack()}>Cancel</Button>{' '}
          </div>
          <div className="col-2">
            <Button type="primary" onClick={() => this.handleCreate()}>
              {this.props.currentId === 0 && <span>Create Template</span>}
              {this.props.currentId > 0 && <span>Save Changes</span>}
            </Button>
          </div>
          <div className="col-1">
            {this.props.currentId > 0 && (
              <Popconfirm
                title="Are you sure you want to delete this record?"
                onConfirm={this.props.handleDelete}
                onCancel={() => {}}
                okText="Yes"
                cancelText="No"
              >
                <Button type="danger" icon="delete" className="mr-2" />
              </Popconfirm>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default Form.create()(LeadProposalView)



// WEBPACK FOOTER //
// ./src/components/templates/ProposalTemplateForm.js